var _defs, _mask, _use, _polygon, _polygon2, _mask2, _g, _polygon3, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNanoS(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "118px",
    height: "104px",
    viewBox: "0 0 118 104",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 28") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-16.1%",
    y: "-16.1%",
    width: "132.1%",
    height: "132.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: 9,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.317647059   0 0 0 0 0.388235294   0 0 0 0 0.48627451  0 0 0 0.110932037 0",
    type: "matrix",
    in: "shadowOffsetOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "36.9888222%",
    y1: "4.03264983%",
    x2: "63.3318789%",
    y2: "94.2913748%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D728F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37475C",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0.809393812 3.19618673 20.9174029 0 56.5398965 71.1542159 36.711965 74.6099597"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDCBDA",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#889CB3",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "36.1972985%",
    y1: "5.62313812%",
    x2: "63.8027015%",
    y2: "97.1281338%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E536A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#293647",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "109.05086%",
    y1: "47.2993321%",
    x2: "22.2812569%",
    y2: "55.042065%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#516177",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#425773",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "69.4517554%",
    y2: "100%",
    id: "linearGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333C4B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#263749",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-9",
    points: "0 1.25823738 8.82393339 0 24.2601715 30.3677202 15.4186381 32.3648275"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-4.1%",
    y: "-3.1%",
    width: "108.2%",
    height: "106.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-11"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "43.8778455%",
    x2: "36.0991816%",
    y2: "56.4076833%",
    id: "linearGradient-12"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7DFE6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93A4B3",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "45.5483728%",
    x2: "60.5733893%",
    y2: "53.0188182%",
    id: "linearGradient-13"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDD7E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3C3D2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.6273932,66.7610956 L110.217399,67.0004491 L110.217399,67.0004491 L110.217399,86.4404491 L40.9282249,87.0137261 C34.9922548,87.0628384 29.9086613,82.7728248 28.959136,76.9130847 C28.1859663,72.1416765 31.4271791,67.646908 36.1985873,66.8737384 C36.6709754,66.7971916 37.1488459,66.7595177 37.6273932,66.7610956 Z",
    id: "path-14"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "1.3%",
    y: "-2.3%",
    width: "99.4%",
    height: "104.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-15"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.567428422   0 0 0 0 0.629610927   0 0 0 0 0.685575181  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1",
    result: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetInner2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner2",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowInnerInner2",
    result: "shadowMatrixInner2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner2"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M47.3996588,68.3786454 C50.978464,68.3786454 53.8796588,64.9793803 53.8796588,60.7861743 C53.8796588,56.5929683 50.978464,53.1937032 47.3996588,53.1937032 C43.8208536,53.1937032 40.9196588,56.5929683 40.9196588,60.7861743 C40.9196588,64.9793803 43.8208536,68.3786454 47.3996588,68.3786454 Z",
    id: "path-16"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-19.3%",
    y: "-16.5%",
    width: "138.6%",
    height: "132.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-17"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -5,
    dy: -4,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.184313725   0 0 0 0 0.219607843   0 0 0 0 0.258823529  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3,
    transform: "translate(-234.000000, -170.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-29",
    transform: "translate(24.000000, 157.661193)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-3",
    transform: "translate(210.000000, 12.338807)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-28",
    filter: "url(#filter-1)",
    transform: "translate(13.560000, 14.555186)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u8DEF\\u5F84-31",
    transform: "translate(4.320000, 0.000000)"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "\\u8499\\u7248",
    fill: "url(#linearGradient-2)",
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-5)",
    opacity: 0.0817987351,
    style: {
      mixBlendMode: "screen"
    },
    mask: "url(#mask-4)",
    points: "55.7966271 25.4805066 16.3191956 72.5993803 -11.88 3.19618673 35.7716653 -21.6"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84-27",
    fill: "url(#linearGradient-6)",
    points: "5.12939381 3.19618673 0 8.27581926 35.2756528 81.2915536 41.031965 74.6099597"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84-28",
    fill: "url(#linearGradient-7)",
    points: "35.2756528 81.2915536 59.2327051 75.8523644 60.8598965 71.1542159 41.031965 74.6099597"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u8DEF\\u5F84-31",
    transform: "translate(15.831494, 11.319656)"
  }, _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u8499\\u7248"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-8)",
    fillRule: "evenodd",
    xlinkHref: "#path-9"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-11)",
    xlinkHref: "#path-9"
  }))), /*#__PURE__*/React.createElement("polygon", {
    fill: "#889CB3",
    opacity: 0.0984468006,
    style: {
      mixBlendMode: "screen"
    },
    mask: "url(#mask-10)",
    points: "32.1307314 -8.51914954 -7.34670014 38.5997241 -18.2658958 10.4460682 21.7614824 -28.4936489"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84-30",
    fill: "url(#linearGradient-12)",
    points: "42.3657433 79.9078708 60.8598965 93.0922352 80.5447999 93.0922352 55.2880745 76.2228848"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\u77E9\\u5F62",
    transform: "translate(68.762985, 76.913085) rotate(34.000000) translate(-68.762985, -76.913085) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-13)",
    fillRule: "evenodd",
    xlinkHref: "#path-14"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-15)",
    xlinkHref: "#path-14"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "\\u692D\\u5706\\u5F62",
    transform: "translate(47.399659, 60.786174) rotate(-39.000000) translate(-47.399659, -60.786174) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-16"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-17)",
    xlinkHref: "#path-16"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2F3842",
    strokeWidth: 1.08,
    d: "M47.3996588,53.7337032 C49.0315451,53.7337032 50.5034377,54.5172424 51.5709691,55.7680451 C52.6670481,57.0522963 53.3396588,58.8278372 53.3396588,60.7861743 C53.3396588,62.7445114 52.6670481,64.5200523 51.5709691,65.8043035 C50.5034377,67.0551062 49.0315451,67.8386454 47.3996588,67.8386454 C45.7677725,67.8386454 44.2958799,67.0551062 43.2283485,65.8043035 C42.1322695,64.5200523 41.4596588,62.7445114 41.4596588,60.7861743 C41.4596588,58.8278372 42.1322695,57.0522963 43.2283485,55.7680451 C44.2958799,54.5172424 45.7677725,53.7337032 47.3996588,53.7337032 Z",
    strokeLinejoin: "square"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNanoS);
export default __webpack_public_path__ + "static/media/nano-s.ed02ed8f51e1febf6aeaf90314cc6896.svg";
export { ForwardRef as ReactComponent };